import { all, fork } from 'redux-saga/effects';
import { accountRecoverySaga } from 'store/AccountRecovery';
import { apiSaga } from 'store/ApiClient';
import { appSaga } from 'store/App';
import { calculatorRulesSaga } from 'store/CalculatorRules';
import { cardSaga } from 'store/Card';
import { collectionsSaga, posCategoriesSagas } from 'store/Collections';
import { employeeSaga } from 'store/Employee';
import { employersSaga } from 'store/Employers';
import { integrationSaga } from 'store/Integration';
import { invitesSaga } from 'store/Invites';
import { laborReviewSaga } from 'store/LaborReview';
import { paymentSaga as paymentSetSaga } from 'store/Payment';
import { payoutSaga } from 'store/Payout';
import { signUpSaga } from 'store/SignUp';
import { siteSaga } from 'store/Site';
import { statsSaga } from 'store/Stats';
import { tipCalculatorSaga } from 'store/TipCalculator';
import { userSaga } from 'store/User';

export function* rootSaga() {
  yield all([
    fork(apiSaga),
    fork(appSaga),
    fork(accountRecoverySaga),
    fork(collectionsSaga),
    fork(payoutSaga),
    fork(tipCalculatorSaga),
    fork(calculatorRulesSaga),
    fork(posCategoriesSagas),
    fork(paymentSetSaga),
    fork(statsSaga),
    fork(employersSaga),
    fork(siteSaga),
    fork(employeeSaga),
    fork(integrationSaga),
    fork(invitesSaga),
    fork(laborReviewSaga),
    fork(userSaga),
    fork(signUpSaga),
    fork(cardSaga),
  ]);
}
